//imgs
import Global from "../../../assets/imgs/job-placement/globe-icon.png";
import Salary from "../../../assets/imgs/job-placement/salary-icon.png";
import Growth from "../../../assets/imgs/job-placement/growth-icon.png";
import Quality from "../../../assets/imgs/job-placement/quality-icon.png";
import Support from "../../../assets/imgs/job-placement/support-icon.png";

export const WC_DATA = [
  {
    name: "Global Recognition",
    imgURL: Global,
  },
  {
    name: "Attractive Salary Packages",
    imgURL: Salary,
  },
  {
    name: "Career Growth",
    imgURL: Growth,
  },
  {
    name: "High Quality of Life",
    imgURL: Quality,
  },
  {
    name: "Support for International Nurses",
    imgURL: Support,
  },
];
